import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RounderPipe} from './rounder.pipe';

@NgModule({
  declarations: [RounderPipe],
  imports: [
    CommonModule,
  ],
  exports: [RounderPipe]
})
export class RounderModule {
}
